import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { queryProductByKey, QUERY_KEY } from 'src/queries/queryProductByKey';

type Product = MCP.Products.ProductSearch.Models.MatchingVersion | null;
type QueryKey = App.SetsConfigs.ProductLookupQueryKey;

export const useQueryProductByKey = (
    accessToken: string | undefined | false,
    productKey: string,
    options?: UseQueryOptions<Product, Error, Product, QueryKey>,
): UseQueryResult<Product, Error> => useQuery<Product, Error, Product, QueryKey>(
    [QUERY_KEY, accessToken, productKey],
    queryProductByKey,
    {
        suspense: false,
        retry: false,
        ...options,
    },
);
